// extracted by mini-css-extract-plugin
module.exports = {"error":"_93444fe79c--error--2sxyx"};